import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { BaseEntity } from '../../models/BaseEntity';
import { generatePullQuery, PullQueryContext } from '../queryBuilders/generatePullQuery';
import { defaultDocAllTime } from '../Shared/defaultDoc';

export interface Department extends BaseEntity {
  readonly description: string;
}

export type DepartmentCollection = RxCollection<Department> | null;
export type DepartmentDocument = RxDocument<Department>;

export const departmentSchema: RxJsonSchema<Department> = {
  type: 'object',
  version: 0,
  description: 'describes a department object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    isDeleted: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
  },
};

const departmentFeedQuery = print(gql`
  query departmentFeed($lastUpdateAt: Float!, $siteId: ID!, $limit: Int!) {
    departmentFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
      description
      id
      isDeleted
      version
      updatedAt
    }
  }
`);

export const departmentPullQueryBuilder = generatePullQuery(
  departmentFeedQuery,
  PullQueryContext.Site,
  defaultDocAllTime,
);

export default {};
